import { get, post, deleteRequest } from "../../../shared/data";

export const getPegholes = (wipKey, shotKey) => {
    return get(`/coding/pegholes/${wipKey}/shots/${shotKey}`)
        .then((response) => {
            return response.items;
        })
        .catch(() => {
            return [];
        });
};

export const savePegholes = (wipKey, shotKey, sourcePage, payload) => {
    return post(`/coding/pegholes/${wipKey}/shots/${shotKey}?sourcePage=${sourcePage}`, {
        items: payload,
    });
};

export const deletePeghole = (wipKey, shotKey) => {
    return deleteRequest(`/coding/pegholes/${wipKey}/shots/${shotKey}`);
};
